module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tableShow) ? _c('div', [_c('h3', {
    staticClass: "title-content mb-5"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('MY_ORDERS')) + "\n    ")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.ordersOnCurrentPage,
      "hide-actions": true,
      "no-data-text": _vm.$t('EMPTY_LIST')
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.number))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$t(props.item.name)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.price))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.orderStatus))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.dateFormat(props.item.dateOrder)))])]
      }
    }], null, false, 3181263430)
  }), _vm._v(" "), (_vm.numberOfPages > 1) ? _c('div', [_c('v-pagination', {
    attrs: {
      "length": _vm.numberOfPages,
      "total-visible": _vm.numberOfTotalVisiblePages,
      "prev-icon": "arrow_back",
      "next-icon": "arrow_forward"
    },
    model: {
      value: (_vm.currentlyDisplayedPage),
      callback: function($$v) {
        _vm.currentlyDisplayedPage = $$v
      },
      expression: "currentlyDisplayedPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rotate-phone mobile"
  }, [_c('p', {
    staticClass: "rotate-phone__text"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ROTATE_PHONE')) + "\n        ")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2934da2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/purchases/purchases.vue
// module id = 1175
// module chunks = 0